import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 500px)
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-188">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-50 md:hidden" data-id="element-189">
          <div className="flex items-center justify-between gap-3 max-w-md mx-auto" data-id="element-190">
            <div className="flex flex-col leading-tight shrink-0" data-id="element-191">
              <span className="text-xs text-gray-500 line-through" data-id="element-192">
                $47.990
              </span>
              <span className="text-lg font-bold text-ocean-teal-dark" data-id="element-193">
                $27.990
              </span>
            </div>
            <a href="https://www.tera-ventasonline.shop/cart/45111856431219:1" target="_blank" rel="noopener noreferrer" className="flex-1 py-3 px-4 bg-ocean-gold hover:bg-ocean-gold-dark text-white rounded-xl font-bold text-sm transition-colors shadow-sm flex items-center justify-center gap-2 text-center" data-id="element-194">
              QUIERO EL SISTEMA 360
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}